import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const PlusCircleIcon = (props: SvgIconProps) => {
    return (
        <SvgIcon viewBox="0 0 25 25" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.9233 4.39301C8.50506 4.39301 4.92334 7.97473 4.92334 12.393C4.92334 16.8113 8.50506 20.393 12.9233 20.393C17.3416 20.393 20.9233 16.8113 20.9233 12.393C20.9233 7.97473 17.3416 4.39301 12.9233 4.39301ZM2.92334 12.393C2.92334 6.87016 7.40049 2.39301 12.9233 2.39301C18.4462 2.39301 22.9233 6.87016 22.9233 12.393C22.9233 17.9159 18.4462 22.393 12.9233 22.393C7.40049 22.393 2.92334 17.9159 2.92334 12.393ZM12.9233 8.39301C13.4756 8.39301 13.9233 8.84072 13.9233 9.39301V11.393H15.9233C16.4756 11.393 16.9233 11.8407 16.9233 12.393C16.9233 12.9453 16.4756 13.393 15.9233 13.393H13.9233V15.393C13.9233 15.9453 13.4756 16.393 12.9233 16.393C12.3711 16.393 11.9233 15.9453 11.9233 15.393V13.393H9.92334C9.37106 13.393 8.92334 12.9453 8.92334 12.393C8.92334 11.8407 9.37106 11.393 9.92334 11.393H11.9233V9.39301C11.9233 8.84072 12.3711 8.39301 12.9233 8.39301Z"
            />
        </SvgIcon>
    );
};

export default PlusCircleIcon;
